import Vue from 'vue'
import NuxtLoading from './components/nuxt-loading.vue'

import _77180f1e from '../layouts/blank.vue'
import _6f6c098b from '../layouts/default.vue'

const layouts = { "_blank": _77180f1e,"_default": _6f6c098b }

export default {
  head: {"title":"Fernando Moreira | Desenvolvedor front-end e WordPress em Curitiba\u002FPR","htmlAttrs":{"dir":"ltr","lang":"pt-br"},"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"og:locale","content":"pt_BR"},{"http-equiv":"Content-Language","content":"pt-br"},{"name":"googlebot","content":"index,follow"},{"name":"robots","content":"index,follow,noodp"},{"name":"country","content":"Brazil"},{"name":"revisit-after","content":"7 days"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"generator","content":"Visual Studio Code - Insiders"},{"hid":"charset","charset":"utf-8"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"nandomoreira.me"},{"hid":"author","name":"author","content":"Fernando Moreira"},{"hid":"description","name":"description","content":"Desenvolvedor front-end e entusiasta da experiência do usuário | Desenvolvedor Front-end em Curitiba | Desenvolvedor WordPress em Curitiba | UX Designer em Curitiba"},{"hid":"theme-color","name":"theme-color","content":"#5bbc8f"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"nandomoreira.me"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"nandomoreira.me"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Desenvolvedor front-end e entusiasta da experiência do usuário | Desenvolvedor Front-end em Curitiba | Desenvolvedor WordPress em Curitiba | UX Designer em Curitiba"}],"link":[{"rel":"author","href":"https:\u002F\u002Fnandomoreira.me\u002Fhumans.txt"},{"rel":"index","href":"https:\u002F\u002Fnandomoreira.me\u002F"},{"rel":"shortcut icon","href":"https:\u002F\u002Fnandomoreira.me\u002Ficon.png","type":"image\u002Fpng"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.55e5cb9c.json"},{"rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512.c1W4Ekfmy_E.png","sizes":"512x512"}],"script":[{"src":"\u002F\u002Fs7.addthis.com\u002Fjs\u002F300\u002Faddthis_widget.js#pubid=ra-5869919cdfa51391","async":true}],"style":[]},

  render(h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })
    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [ layoutEl ])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [ templateEl ])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,
      transitionEl
    ])
  },
  data: () => ({
    isOnline: true,
    layout: null,
    layoutName: ''
  }),
  beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created() {
    // Add this.$nuxt in child instances
    Vue.prototype.$nuxt = this
    // add to window so we can listen when ready
    if (process.client) {
      window.$nuxt = this
      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
  },

  mounted() {
    this.$loading = this.$refs.loading
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline() {
      return !this.isOnline
    }
  },
  methods: {
    refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    errorChanged() {
      if (this.nuxt.err && this.$loading) {
        if (this.$loading.fail) this.$loading.fail()
        if (this.$loading.finish) this.$loading.finish()
      }
    },

    setLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    }
  },
  components: {
    NuxtLoading
  }
}
